import { Settings } from "../../app.settings.model";
import { AuthService } from '../../shared/services/auth.service';

export class User {
  id: number;
  idecatpro: number;
  business_id: number;
  business: Business;
  createdBy: number;
  registration: string;
  plan: string;
  inst_id: number;
  level_id: number;
  role: Role;
  rolePermissions: RolePermission[];
  customPermissions?: string[];
  settings: Settings;
  name: string;
  lastname: string;
  username: string;
  password: string;
  gender: string;
  email: string;
  correo_institucional: string;
  curp: string;
  active: boolean;
  photo: string;
  cellPhone;
  from: string;
  person_id: string;
  last_login: string;
  message_invo: number;
  idecatalu: number;

  constructor(id: number = 0, photo: string = '', name: string = '') {
    this.id = id;
    this.photo = photo;
    this.name = name;
    this.role = new Role();
    this.active = true;
  }

}

export class Role {
  id: number;
  name: string;
}

export class Business {
  id: number;
  name: string;
}

export class TypeCedula {
  id: number;
  description: string;
}

export class TypesInsurances {
  id: number;
  description: string;
}

export class Module {
  id: number;
  name: string;
  disabled: boolean;
}

export class TypeInsurance {
  id: number;
  description: string;
}

export class RolePermission {
  id: number;
  role_id: number;
  module_id: number;
  edit: number;
  delete: number;
  upload: number;
  reject: number;
  update: number;
  verify: number;
  maintenance: number;

  constructor() {
  }
}

export class CustomPermission {
  id: number;
  user_id?: number;
  perm_key: string;
  description?: string;
  is_granted?: boolean;
}

export class UserProfile {
  name: string;
  lastname: string;
  gender: string;
  photo: string;
}

export class UserWork {
  company: string;
  position: string;
  salary: number;
}

export class UserContacts {
  email: string;
  phone: string;
  address: string;
}

export class UserSocial {
  facebook: string;
  twitter: string;
  google: string;
}

export class UserSettings {
  isActive: boolean;
  isDeleted: boolean;
  registrationDate: Date;
  joinedDate: Date;
}
